import React, { Component } from "react";
import styles from "./monitoringsTaskTripsBar.module.scss";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import Input from "../../../../shared/items/contols/input";
import Icon from "../../../../shared/items/static/icon";
import { states } from "../../../../reducers/queriesStates";

class MonitoringsTaskTripsSearch extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { onGetMonitoringsTaskTrips, searchTerm } = this.props;
   
    onGetMonitoringsTaskTrips({ searchTerm });
  }

  handleChangeStore(name, searchTerm) {
    const { onGetMonitoringsTaskTrips, onSetSeatchTerm } = this.props;
    onSetSeatchTerm(searchTerm);
    onGetMonitoringsTaskTrips({ searchTerm });
  }

  onClickSearch() {
    const { onGetMonitoringsTaskTrips, searchTerm } = this.props;

    onGetMonitoringsTaskTrips({ searchTerm });
  }

  render() {
    const { onGetMonitoringsTaskTrips, searchTerm } = this.props;

    return (
      <div className={styles.searchTrips}>
        <Input
          name="searchTerm"
          type="text"
          store={{}}
          handleChangeStore={this.handleChangeStore.bind(this)}
          placeholder="Поиск"
          defaultValue={searchTerm}
        />
        <div
          className={styles.container_searchBtn}
          onClick={(e) => {
            e.stopPropagation();
            this.onClickSearch();
          }}
        >
          <Icon name="search" />
        </div>
      </div>
    );
  }
}

export default withMonitoringTaskTrips(React.memo(MonitoringsTaskTripsSearch));
